import { registerBlockType } from '@wordpress/blocks';
import edit from './edit';
import save from './save';

import './style.scss';

registerBlockType('monfort/banner-slider', {
    "title": "Monfort Banner Slider",
    "category": "layout",
    "icon": "cover-image",
    "attributes": {
    "slides": {
      "type": "array",
      "default": []
    }
    },
    edit,
    save,
});

